import { render } from "./dungeonidleprivacypolicy.vue?vue&type=template&id=c59d49de&scoped=true"
import script from "./dungeonidleprivacypolicy.vue?vue&type=script&lang=js"
export * from "./dungeonidleprivacypolicy.vue?vue&type=script&lang=js"

import "./dungeonidleprivacypolicy.vue?vue&type=style&index=0&id=c59d49de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59d49de"]])

export default __exports__